import { render, staticRenderFns } from "./AdAcountData.vue?vue&type=template&id=dda71906&scoped=true"
import script from "./AdAcountData.vue?vue&type=script&lang=js"
export * from "./AdAcountData.vue?vue&type=script&lang=js"
import style0 from "./AdAcountData.vue?vue&type=style&index=0&id=dda71906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda71906",
  null
  
)

export default component.exports